import { ReactElement, useContext, useEffect } from "react";
import { Alert } from "@justworkshr/milo-core";

import PageAlertContext from "contexts/PageAlertContext";

const PageAlert = (): ReactElement => {
  const { alert, removeAlert } = useContext(PageAlertContext);
  const { message, color } = alert;

  useEffect(() => {
    if (!message) return;

    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [message]);

  return (
    <>
      {!!message && (
        <Alert color={color} dismissible={true} onDismiss={removeAlert}>
          {message}
        </Alert>
      )}
    </>
  );
};

export default PageAlert;
